/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface UpdateLootBoxConfigResponse
 */
export interface UpdateLootBoxConfigResponse {
    /**
     * 
     * @type {LootBoxConfigResponse}
     * @memberof UpdateLootBoxConfigResponse
     */
    lootBoxConfig: LootBoxConfigResponse;
}

/**
 * Check if a given object implements the UpdateLootBoxConfigResponse interface.
 */
export function instanceOfUpdateLootBoxConfigResponse(value: object): value is UpdateLootBoxConfigResponse {
    if (!('lootBoxConfig' in value) || value['lootBoxConfig'] === undefined) return false;
    return true;
}

export function UpdateLootBoxConfigResponseFromJSON(json: any): UpdateLootBoxConfigResponse {
    return UpdateLootBoxConfigResponseFromJSONTyped(json, false);
}

export function UpdateLootBoxConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLootBoxConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootBoxConfig': LootBoxConfigResponseFromJSON(json['lootBoxConfig']),
    };
}

export function UpdateLootBoxConfigResponseToJSON(json: any): UpdateLootBoxConfigResponse {
    return UpdateLootBoxConfigResponseToJSONTyped(json, false);
}

export function UpdateLootBoxConfigResponseToJSONTyped(value?: UpdateLootBoxConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootBoxConfig': LootBoxConfigResponseToJSON(value['lootBoxConfig']),
    };
}

